import {useEffect} from 'react';
import {useServiceProviderStore} from '../store/serviceProviderStore';
import {PAGINATION_CONFIG} from '../../../constants/appConfig';

export const useServiceProviders = () => {
  const {
    providers,
    pagination,
    loading,
    error,
    fetchProviders
  } = useServiceProviderStore();

  // Initial data fetch
  useEffect(() => {
    fetchProviders(1, PAGINATION_CONFIG.DEFAULT_PAGE_SIZE);
  }, []);

  const handlePageChange = (newPage: number) => {
    const currentLimit = pagination?.limit || PAGINATION_CONFIG.DEFAULT_PAGE_SIZE;
    fetchProviders(newPage, currentLimit);
  };

  const handlePageSizeChange = (newPageSize: number) => {
    fetchProviders(1, newPageSize);
  };

  return {
    serviceProviders: providers,
    pagination,
    loading,
    error,
    handlePageChange,
    handlePageSizeChange,
    refetch: () => {
      const currentPage = pagination?.page || 1;
      const currentLimit = pagination?.limit || PAGINATION_CONFIG.DEFAULT_PAGE_SIZE;
      fetchProviders(currentPage, currentLimit);
    }
  };
};
